<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.payment}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <message :messages="messages"></message>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="paytModeList" v-model="motorForm.paytMode" :label="labels.paytMode" item-text="label" item-value="value" data-vv-name="paytMode" :data-vv-as="labels.paytMode" :error-messages="errors.collect('paytMode')" v-validate="'required'"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
            <template v-if="motorForm.paytMode === 'CC'">
              <v-flex lg6 xs12>
                <v-text-field ref="paytCCNo" v-creditcard-mask key="paytCCNo" :prepend-icon="ccIcon" v-model="paytCCNo" :label="labels.paytCCNo" :error-messages="errors.collect('paytCCNo')" data-vv-name="paytCCNo" :data-vv-as="labels.paytCCNo" v-validate="'required|credit_card'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field key="paytCCName" prepend-icon="mdi-account-card-details" v-model="motorForm.paytCCName" :label="labels.paytCCName" :error-messages="errors.collect('paytCCName')" data-vv-name="paytCCName" :data-vv-as="labels.paytCCName" v-validate="'required|max:100'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field ref="paytExpDate" v-creditcard-exp-mask key="paytExpDate" prepend-icon="mdi-calendar" persistent-hint hint="MM-YYYY" v-model="paytExpDate" :label="labels.paytExpDate" :error-messages="errors.collect('paytExpDate')" data-vv-name="paytExpDate" :data-vv-as="labels.paytExpDate" v-validate="'required|credit_card_exp'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field key="paytCCCvv" v-int-mask="{intScale: 5}" type="tel" prepend-icon="mdi-textbox-password" v-model="motorForm.paytCCCvv" :label="labels.paytCCCvv" :error-messages="errors.collect('paytCCCvv')" data-vv-name="paytCCCvv" :data-vv-as="labels.paytCCCvv" v-validate="'required|max:5|numeric'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-autocomplete :items="paytInstalmentPlanList" v-model="motorForm.paytInstalmentPlan" :label="labels.paytInstalmentPlan" item-text="label" item-value="value" data-vv-name="paytInstalmentPlan" :data-vv-as="labels.paytInstalmentPlan" :error-messages="errors.collect('paytInstalmentPlan')"  v-validate="'required'"></v-autocomplete>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3" v-if="$mode !== 'ecics'">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" dark type="submit" :loading="quotation.saving" @click.prevent="doInForceProposal" v-if="checkAccess(['motorQuoteRef', 'motorQuoteSTP'])">
        In-Force Proposal
        <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
      </v-btn>
      <v-btn color="primary" type="submit" :loading="quotation.saving" @click.prevent="doSubmitReview">
        Send for Review
        <v-icon right dark>mdi-account-check</v-icon>
      </v-btn>
    </v-layout>
    <v-layout row wrap class="mt-3" v-else>
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" dark type="submit" :loading="quotation.saving" @click.prevent="doInForceProposal" v-if="perStp">
        In-Force Proposal
        <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
      </v-btn>
      <v-btn color="primary" type="submit" :loading="quotation.saving" @click.prevent="doSubmitReview" v-if="!perStp">
        Send for Review
        <v-icon right dark>mdi-account-check</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_PARAM, PROPOSAL_MOTOR_PAYMENT, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { PaymentMixin } from '../../shared/paymentMixin'
import { paymentMode, paymentInstalmentPlan } from '@/const/underwriting/motor'
import { generalMotorForm } from '@/store/modules/agency/actions/quote'
import { extractRecord } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      motorForm: {
        // Contains values for submit
        paytMode: undefined,
        paytCCNo: undefined,
        paytCCName: undefined,
        paytCCType: undefined,
        paytCCExpMth: undefined,
        paytCCExpYr: undefined,
        paytCCCvv: undefined,
        paytInstalmentPlan: undefined
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    paytModeList() {
      let result = []
      Object.keys(paymentMode).forEach(function (key) {
        const status = paymentMode[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    paytInstalmentPlanList() {
      let result = []
      Object.keys(paymentInstalmentPlan).forEach(function (key) {
        const status = paymentInstalmentPlan[key]
        result.push({
          label: status,
          value: Number(key)
        })
      })
      return result
    },
    perStp() {
      const param = extractRecord(this.quoteParam.busCls, this.globalForm.busCls)
      if (param) {
        return param.perSTP
      }
      return false
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.motorForm.paytMode = this.globalCommonForm.paytMode
      this.motorForm.paytCCNo = this.globalCommonForm.paytCCNo
      this.paytCCNo = this.globalCommonForm.paytCCNo
      this.motorForm.paytCCName = this.globalCommonForm.paytCCName
      this.motorForm.paytCCType = this.globalCommonForm.paytCCType
      this.motorForm.paytCCExpMth = this.globalCommonForm.paytCCExpMth
      this.motorForm.paytCCExpYr = this.globalCommonForm.paytCCExpYr
      this.motorForm.paytCCCvv = this.globalCommonForm.paytCCCvv
      this.motorForm.paytInstalmentPlan = this.globalCommonForm.paytInstalmentPlan

      if (this.motorForm.paytMode === undefined || this.motorForm.paytMode === null) {
        if (this.paytModeList.length > 0) {
          this.motorForm.paytMode = this.paytModeList[0].value
        }
      }
      if (this.motorForm.paytInstalmentPlan === undefined || this.motorForm.paytInstalmentPlan === null) {
        this.motorForm.paytInstalmentPlan = this.paytInstalmentPlanList[0].value
      }
      if (this.motorForm.paytCCExpMth && this.motorForm.paytCCExpYr) {
        this.formatExpDate(this.motorForm.paytCCExpMth, this.motorForm.paytCCExpYr)
      }
      if (this.$mode === 'ecics') {
        this.getBusCls()
      }
    },
    async getBusCls() {
      const apiURI = this.$store.state.agency.quotation.menu.busCls
      if (apiURI) {
        try {
          const expand = {
            product: this.globalCommonForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              busCls: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
      this.$router.push({ name: 'motorProposalPremium' })
    },
    doInForceProposal() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doProcessForm()
          this.$store.commit(PROPOSAL_MOTOR_PAYMENT, this.motorForm)
          this.proceessInforce()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doSubmitReview() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doProcessForm()
          this.$store.commit(PROPOSAL_MOTOR_PAYMENT, this.motorForm)
          this.proceessReview()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async proceessReview() {
      const apiUrl = this.quotation.menu.refNewProposal
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Proposal has been submitted for review')

          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async proceessInforce() {
      const apiUrl = this.quotation.menu.proceedNewProposal
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Proposal has been In-Forced')

          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo }, query: { if: true } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doPartialSave() {
      try {
        this.doProcessForm()
        this.$store.commit(PROPOSAL_MOTOR_PAYMENT, this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    doProcessForm() {
      // CC Type
      if (this.motorForm.paytMode === 'CC') {
        this.motorForm.paytCCType = this.backEndCCTypeFormat()

        // UnMask
        this.$refs.paytCCNo.$el.cleave.setRawValue(this.paytCCNo)
        this.motorForm.paytCCNo = this.$refs.paytCCNo.$el.cleave.getRawValue()

        if (this.paytExpDate) {
          this.motorForm.paytCCExpMth = null
          this.motorForm.paytCCExpYr = null
          const splitArr = this.paytExpDate.split('-')
          if (splitArr && splitArr.length === 2) {
            if (splitArr[0].length === 2 && splitArr[1].length === 4) {
              this.motorForm.paytCCExpMth = Number(splitArr[0])
              this.motorForm.paytCCExpYr = Number(splitArr[1])
            }
          }
        }
      } else {
        this.motorForm.paytCCNo = undefined
        this.motorForm.paytCCName = undefined
        this.motorForm.paytCCType = undefined
        this.motorForm.paytCCExpMth = undefined
        this.motorForm.paytCCExpYr = undefined
        this.motorForm.paytCCCvv = undefined
        this.motorForm.paytInstalmentPlan = undefined
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 5) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin,
    PaymentMixin
  ]
}
</script>

<style lang="scss">

</style>
